<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Compensation Occupations</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateCompensationOccupation()">
        <mat-icon>add</mat-icon>
        Add Compensation Occupation
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="compensationOccupations()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCompensationOccupation($event)"
      (deleteClick)="onDeleteCompensationOccupation($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
